import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import { Row, Col, Typography, Form, Input, Button } from "antd";
import { UserOutlined, MailOutlined, SendOutlined, WarningOutlined, LoginOutlined } from "@ant-design/icons";

import { PageLoading } from "./../../component/PageLoading";
import { SearchSelect } from "./../../component/Button";
import { validationsUser } from "./../../shared/formValidation";
import CustomModal from "../../component/ModalCustom";

import UserAdminService from "../../systems/cuadro_mando/services/UserAdminService";
import { colPropsSpan24, colPropsSpan12, COLOR_WARNING, CATALOGO_MENSAJES } from "./../../shared/constants";

import { useSchools } from "./../../hooks/useSchools"
import { useSystems } from "../../hooks/catalog/useSystems";

const { Title, Text } = Typography;


export default function SingnInForm() {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const {catalogSystems, fetchAllSystems} = useSystems();
  const { schoolsList: schools, fetchSchools } = useSchools();

  const [dataModal, setDataModal] = useState(
    {
      icon: <SendOutlined />,
      title: CATALOGO_MENSAJES.accessRequestTitle,
      message: CATALOGO_MENSAJES.Requestmenssage,
      modalVisible: false
    }
  );

  useEffect(() => {
    setLoading(true);
    Promise.all(
      [
        fetchSchools(),
        fetchAllSystems(true)
      ]
    );
    setLoading(false);
  }, []);

  const showModalMessage = (message) => {
    setDataModal({ ...dataModal, message: message, modalVisible: true });
  };

  const onFinish = async (values) => {
    setLoading(true);
    const response = await UserAdminService.createUser(values);
    setLoading(false);
    if (!response.success) {
      setDataModal({ icon: <WarningOutlined />, title: CATALOGO_MENSAJES.accessRequestTitle, message: response.message, modalVisible: true, color: COLOR_WARNING });
    } else {
      showModalMessage(response.message);
      form.resetFields();
    }
  };

  const finishFailed = () => {
  };

  return (
    <>
      <PageLoading loading={loading} >
        <Row className="paddingPersonalizado">
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={finishFailed}
          >
            <Row>
              <Title className="pompisSemiBold titleColor" level={2}>
                Solicitud de acceso
              </Title>
            </Row>
            <Row>
              <Text className="pompisLight textColor">
                Por favor, completa los campos con la información requerida para enviar
                tu solicitud y obtener acceso al Tablero.
              </Text>
            </Row>
            <div style={{ marginBottom: "20px" }} />
            <Row>
              <Col {...colPropsSpan24}>
                <Form.Item
                  label="Nombre"
                  name="nombre"
                  rules={validationsUser.nombre}
                >
                  <Input
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Nombre"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col {...colPropsSpan12}>
                <Form.Item
                  label="Primer Apellido"
                  name="primer_apellido"
                  rules={validationsUser.primerApellido}
                >
                  <Input
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Primer Apellido"
                  />
                </Form.Item>
              </Col>
              <Col {...colPropsSpan12}>
                <Form.Item
                  label="Segundo Apellido"
                  name="segundo_apellido"
                  rules={validationsUser.segundoApellido}
                >
                  <Input
                    prefix={<UserOutlined className="site-form-item-icon" />}
                    placeholder="Segundo Apellido"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col {...colPropsSpan24}>
                <Form.Item
                  label="Correo Institucional"
                  name="correo_institucional"
                  rules={validationsUser.correoInstitucional}
                >
                  <Input
                    prefix={<MailOutlined className="site-form-item-icon" />}
                    placeholder="Correo Institucional"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col {...colPropsSpan24}>
                <Form.Item
                  label="Unidad Administrativa / Plantel"
                  name="id_plantel"
                  rules={validationsUser.plantel}
                >
                  <SearchSelect
                    loading={false}
                    disabled={false}
                    placeholder="Selecciona tu unidad administrativa o plantel "
                    dataset={schools}
                    required
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col {...colPropsSpan24}>
                <Form.Item
                  label="Sistema al que deseas acceder"
                  name="system_key"
                  rules={[{ required: true, message: 'Por favor selecciona el sistema al que deseas acceder' }]}
                >
                  <SearchSelect
                    loading={loading}
                    disabled={catalogSystems.length === 0}
                    placeholder="Selecciona el sistema al que deseas acceder"
                    dataset={catalogSystems}
                    required
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col align="middle" {...colPropsSpan24}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="custom-submit-button"
                  >
                    Solicitar acceso
                  </Button>
                </Form.Item>
              </Col>
              <ButtonLogIn />
            </Row>
          </Form>
        </Row>
      </PageLoading>
      <CustomModal
        dataModal={dataModal}
        setDataModal={setDataModal} />
    </>

  );
}

const ButtonLogIn = () => {
  return (
    <Col align="middle" {...colPropsSpan24}>
      <NavLink to={"/iniciar-sesion"}>
        <Button
          type="dashed"
          icon={<LoginOutlined />}
        >
          Iniciar sesion
        </Button>
      </NavLink>
    </Col>
  );
}
